import { makeStyles, createStyles } from '@material-ui/core/styles';
import { variables } from '../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    partnershipCard: {
      height: 19,
      borderRadius: 4,
      paddingRight: 4,
      paddingLeft: 4,
      marginRight: 4,
      backgroundColor: variables.black5,
      color: variables.richBlack,
      boxShadow: 'none',
      fontSize: 12,
      width: 'fit-content',
    },
  }),
);
